import { sanitizeName } from './sanitize-name'

// OSS 上 project 层路径（相对 storage 根）：
//   /projects/<projectName>_<projectId>
// tenant id 由 storage prefix 保证
export const buildOssProjectPath = (projectName: string, projectId: string): string =>
  `/projects/${sanitizeName(projectName)}_${projectId}`
